export type Route =
  | { readonly name: 'home' }
  | { readonly name: 'replay'; readonly id: string }
  | { readonly name: 'not-found'; readonly path: string }

const REPLAY = /^\/r\/([A-Za-z0-9_-]{1,64})\/?$/

export const matchRoute = (path: string): Route => {
  if (path === '/' || path === '') return { name: 'home' }
  const replay = REPLAY.exec(path)
  if (replay?.[1]) return { name: 'replay', id: replay[1] }
  return { name: 'not-found', path }
}

export const replayPath = (id: string): string => `/r/${encodeURIComponent(id)}`

export type Router = {
  readonly navigate: (path: string) => void
  readonly current: () => Route
  readonly stop: () => void
}

/** Minimal pushState router. Links marked `data-link` are intercepted. */
export const createRouter = (onChange: (route: Route) => void): Router => {
  const emit = (): void => onChange(matchRoute(location.pathname))
  const navigate = (path: string): void => {
    if (path === location.pathname) return
    history.pushState(null, '', path)
    emit()
  }
  const onClick = (event: Event): void => {
    const target = (event.target as Element | null)?.closest('a[data-link]')
    if (!(target instanceof HTMLAnchorElement) || event.defaultPrevented) return
    const mouse = event as MouseEvent
    if (mouse.metaKey || mouse.ctrlKey || mouse.shiftKey || mouse.button !== 0) return
    event.preventDefault()
    navigate(target.getAttribute('href') ?? '/')
  }
  window.addEventListener('popstate', emit)
  document.addEventListener('click', onClick)
  emit()
  return {
    navigate,
    current: () => matchRoute(location.pathname),
    stop: () => {
      window.removeEventListener('popstate', emit)
      document.removeEventListener('click', onClick)
    },
  }
}
